const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  header: {
    padding: '8px 0px',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#111827',
    marginBottom: '4px',
    fontFamily: 'Inter',
  },
  helperText: {
    fontSize: '12px',
    color: '#6B7280',
    marginTop: '4px',
    fontFamily: 'Inter',
  },
  imageUpload: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
  },
  removeImageButton: {
    color: '#4F46E5',
    textDecoration: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    background: 'none',
    border: 'none',
    padding: 0,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  uploadButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 16px',
    backgroundColor: '#F9FAFB',
    border: '1px solid #E5E7EB',
    borderRadius: '4px',
    color: '#374151',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'Inter',
    '&:hover': {
      backgroundColor: '#F3F4F6',
    },
  },
})

export default styles
